// extracted by mini-css-extract-plugin
var _1 = "jhllXpoQ7FWXJU92RiaT";
var _2 = "xIC51La7A2wElFzLvEVr";
export { _1 as "container", _2 as "select" }
